// Enum del nuevo KDS basado en KitchenTickets. Es independiente del
// DisplayState viejo (que sigue usándose en el sidebar TPV y el flujo de
// facturación). NO mezclar — cada uno tiene su tabla de origen.
export const KitchenTicketState = {
  PENDING: 0,
  PREPARING: 1,
  READY: 2,
  DELIVERED: 3,
  CANCELLED: 4,
};

export const getStatusText = (state) => {
  switch (state) {
    case KitchenTicketState.PENDING:
      return "Pendiente";
    case KitchenTicketState.PREPARING:
      return "En Preparación";
    case KitchenTicketState.READY:
      return "Listo";
    case KitchenTicketState.DELIVERED:
      return "Entregado";
    case KitchenTicketState.CANCELLED:
      return "Cancelado";
    default:
      return "Desconocido";
  }
};

export const getStatusIcon = (state) => {
  switch (state) {
    case KitchenTicketState.PENDING:
      return "🔵";
    case KitchenTicketState.PREPARING:
      return "🟡";
    case KitchenTicketState.READY:
      return "🟢";
    case KitchenTicketState.DELIVERED:
      return "✅";
    case KitchenTicketState.CANCELLED:
      return "🔴";
    default:
      return "⚪";
  }
};

// Máquina de estados local (espejo de la del back). Solo para etiquetas y UI.
// La autoridad sigue siendo el back: el front llama Advance/Back y el back
// computa el nuevo estado.
export const getNextStatus = (state) => {
  switch (state) {
    case KitchenTicketState.PENDING:
      return KitchenTicketState.PREPARING;
    case KitchenTicketState.PREPARING:
      return KitchenTicketState.READY;
    case KitchenTicketState.READY:
      return KitchenTicketState.DELIVERED;
    default:
      return state;
  }
};

export const getPreviousStatus = (state) => {
  switch (state) {
    case KitchenTicketState.DELIVERED:
      return KitchenTicketState.READY;
    case KitchenTicketState.READY:
      return KitchenTicketState.PREPARING;
    case KitchenTicketState.PREPARING:
      return KitchenTicketState.PENDING;
    default:
      return state;
  }
};

// Un ticket es "operable" en el KDS si tiene algo que el cocinero pueda
// mover. Para productos normales (no menú) basta con que exista. Para los
// menús el padre es invisible en el KDS — solo se ven sus lines explotadas
// como filas top-level. Sin lines un ticket-menú pintaría una tarjeta vacía
// sin acciones, así que lo descartamos. Defensa frente a datos sucios
// generados antes del fix del dispatcher en DispatchFromProductos.
export const isOperableTicket = (ticket) => {
  if (!ticket) return false;
  if (ticket.isMenu) {
    return Array.isArray(ticket.lines) && ticket.lines.length > 0;
  }
  return true;
};

// El "estado efectivo" de un ticket en el KDS = mínimo entre ticket.state
// y los states de sus lines activas. Si una line se queda atrás (porque el
// cocinero las gestiona por separado), el ticket aparece en la columna
// donde esté la más atrasada.
export const getEffectiveState = (ticket) => {
  if (!ticket) return KitchenTicketState.PENDING;
  let min = ticket.state;
  if (Array.isArray(ticket.lines)) {
    for (const line of ticket.lines) {
      if (line.state < min) min = line.state;
    }
  }
  return min;
};
